<script>
import useVuelidate from '@vuelidate/core';

/* COMPOSANTS */
import LitigeItem from '@views/litige/components/LitigeItem.vue';

/* MIXINS */

/* SERVICES */

export default {
  components: {LitigeItem},
  mixins: [],
  props: {
    modelValue: {
      required: true,
    },
    submitted: {
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayForSidebar: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayFiles: {
      type: Boolean,
      required: false,
      default: true,
    },
    displayMaintenanceFiles: {
      type: Boolean,
      required: false,
      default: false,
    },
    displayMaintenanceDate: {
      type: Boolean,
      required: false,
      default: false,
    },
    canDeleteFiles: {
      type: Boolean,
      required: false,
      default: true,
    },
    canUploadFiles: {
      type: Boolean,
      required: false,
      default: true,
    },
    bgClass: {
      type: String,
      required: false,
      default: '',
    },
  },
  setup() {
    return {v$: useVuelidate()};
  },
  data() {
    return {};
  },
  emits: ['removed', 'amount-changed'],
  computed: {
    currentValue: {
      get: function () {
        return this.modelValue;
      },
      set: function (val) {
        this.$emit('update:modelValue', val);
      },
    },
  },
  methods: {
    removed() {
      this.$emit('removed');
    },
    amountChanged() {
      this.$emit('amount-changed');
    },
  },
};
</script>

<template>
  <LitigeItem
    v-for="(item, idx) in this.currentValue"
    ref="item"
    v-bind:key="item.id"
    v-model="this.currentValue[idx]"
    :submitted="this.submitted"
    :disabled="this.disabled"
    :index="idx"
    :displayForSidebar="displayForSidebar"
    :displayFiles="displayFiles"
    :displayMaintenanceFiles="displayMaintenanceFiles"
    :displayMaintenanceDate="displayMaintenanceDate"
    :bgClass="bgClass"
    :canDeleteFiles="canDeleteFiles"
    :canUploadFiles="canUploadFiles"
    @amount-changed="amountChanged"
    @removed="removed" />
</template>
